var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_53176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0057 14.7044C13.4086 15.1024 12.7151 15.3129 12 15.3129C11.285 15.3129 10.5914 15.1024 9.99431 14.7044L0.159797 8.14783C0.105234 8.11145 0.0520781 8.07353 0 8.03453V18.7781C0 20.0099 0.999609 20.9875 2.20936 20.9875H21.7906C23.0224 20.9875 24 19.9879 24 18.7781V8.03448C23.9478 8.07358 23.8945 8.11159 23.8398 8.14802L14.0057 14.7044Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.939844 6.9777L10.7744 13.5343C11.1466 13.7825 11.5733 13.9066 12 13.9066C12.4267 13.9066 12.8534 13.7825 13.2256 13.5343L23.0602 6.9777C23.6487 6.58559 24 5.92934 24 5.22106C24 4.0032 23.0092 3.01245 21.7914 3.01245H2.20861C0.990797 3.0125 0 4.00325 0 5.22223C0 5.92934 0.351375 6.58559 0.939844 6.9777Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_53176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7ec48202d787a6dd9babae50a305f4ad.svg";
export { ForwardRef as ReactComponent };